import { ref, onMounted, onBeforeUnmount } from 'vue';
import { usePedidoStore } from '@/stores/pedido';

export default function useColumnUpdater() {
  const pedidoStore = usePedidoStore();
  const updateTimeouts = ref({});
  const abortControllers = ref({});

  const startColumnUpdate = (columnKey, interval = 30000) => {
    stopColumnUpdate(columnKey); // Garantir que não há atualizações duplicadas

    const updateFunction = async () => {
      if (abortControllers.value[columnKey]) {
        abortControllers.value[columnKey].abort();
      }

      const controller = new AbortController();
      abortControllers.value[columnKey] = controller;

      try {
        // Consulta automática com a flag autoUpdate
        await pedidoStore.buscarPedidosPorColuna(columnKey, {
          silent: true,
          signal: controller.signal,
          autoUpdate: true, // Buscar todas as páginas até a página atual
        });
      } catch (error) {
      } finally {
        // Reagendar a próxima atualização
        updateTimeouts.value[columnKey] = setTimeout(updateFunction, interval);
      }
    };

    // Executar a primeira atualização
    updateFunction();
  };

  const stopColumnUpdate = (columnKey) => {
    if (updateTimeouts.value[columnKey]) {
      clearTimeout(updateTimeouts.value[columnKey]);
      delete updateTimeouts.value[columnKey];
    }

    if (abortControllers.value[columnKey]) {
      abortControllers.value[columnKey].abort();
      delete abortControllers.value[columnKey];
    }
  };

  const stopAllUpdates = () => {
    Object.keys(updateTimeouts.value).forEach(stopColumnUpdate);
  };

  onBeforeUnmount(() => {
    stopAllUpdates();
  });

  return {
    startColumnUpdate,
    stopColumnUpdate,
    stopAllUpdates,
  };
}
